import { CompanyTitledPage } from '../../TitledPage';
import { SubTitle } from './component/Header';
import { Content } from './component/ContentInput';  
import { useModeID } from './hook/useModeID';
import { validationSchema } from './component/ValidationSchema';
import { searchSelectNews, insertNews, updateNews } from "../../../http/api/NewsApi";
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import * as Yup from "yup";

export default function NewsEditPage() {
  const navigate = useNavigate();
  const { screenMode, newsId } = useModeID();
  const [saveCondition , setSaveCondition] = useState({
    title: "",
    contentText : ""
  })
  const [errors, setErrors] = useState({
    title: "",
    contentText: "" 
  });
  
  useEffect(() => {
    onLoadPage();
  }, []);

  // 初期表示 ----------------------------------------------------
  const onLoadPage = () => {
    if (screenMode === 2) {
      search(newsId);
    }
  }

  // 検索 --------------------------------------------------------
  async function search (newsId) {
    try{
      const res = await searchSelectNews({
        newsId: newsId,
        newsListPage: 1,
        itemsPerPage: 1,
        keyword: "",
        updateDatePeriodStart: "",
        updateDatePeriodEnd: ""
      });
      if (res.newsListInfo && res.newsListInfo.newsList && res.newsListInfo.newsList.length > 0) {
        const news = res.newsListInfo.newsList[0];
        setSaveCondition({title: news.title, contentText: news.contentText})
      } else {
        setSaveCondition({title: "", contentText: ""})
      }
    } catch {
      setSaveCondition({title: "", contentText: ""})
    }
  };

  // バリデーションチェック--------------------------------------------
  async function validateData (data, field) {
    try {
      const schema = field ? Yup.object({ [field]: validationSchema.fields[field] }) : validationSchema;
      await schema.validate(data, { abortEarly: false });
      setErrors(prevErrors => ({
        ...prevErrors,
        [field]: ""
      }));
      return true;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const newErrors = {};
        error.inner.forEach(err => {
          newErrors[err.path] = err.message;
        });
        setErrors(prevErrors => ({
          title: newErrors['title'] || prevErrors.title,
          contentText: newErrors['contentText'] || prevErrors.contentText
        }));
      }
      return false;
    }
  };

  // ボタン押下 -------------------------------------------------------
  async function handleClickSave() {
    const isValid = await validateData(saveCondition);
    if (!isValid) {
      alert('入力不正項目があるため、確認をお願いいたします。');
      return;
    }

    if (screenMode === 1) {
      insert(saveCondition);
    } else if (screenMode === 2) {
      update(newsId, saveCondition);
    }
  };

  // 登録 --------------------------------------------------------------
  async function insert (saveCondition) {
    try{
      await insertNews({
        title: saveCondition.title,
        contentText: saveCondition.contentText
      });
      alert("登録が完了しました。");
      navigate(-1);
    } catch(error) {
      alert("登録に失敗しました。");
      console.log(error);
    }
  };

  // 更新 --------------------------------------------------------------
  async function update (newsId, saveCondition) {
    try{
      await updateNews({
        newsId: newsId,
        title: saveCondition.title,
        contentText: saveCondition.contentText
      });
      alert("更新が完了しました");
      navigate(-1);
    } catch {
      alert("更新に失敗しました。");
    }
  };

  // 戻る --------------------------------------------------------------
  const handleClickReturn = (e) => {
    navigate(-1);
  };
  
  return (
    <CompanyTitledPage title="お知らせ">
      <SubTitle 
        screenMode={screenMode}
        onClickSave={handleClickSave}
        onClickReturn={handleClickReturn}
      />
      <Content
        screenMode={screenMode}
        newsId={newsId}
        saveCondition={saveCondition}
        setSaveCondition={setSaveCondition}
        errors={errors}
        validateData={validateData}
      />
    </CompanyTitledPage>
  );
};